import { USER_ROLE } from '@socialive/common';

const ROLE_KEY = 'role';

/**
 * Helper function to build rsql filter string.
 * It takes the key and values to be searched and values can be customized on object creation.
 * @param {Object} searchObject search object to be converted
 * @param {Bool} removeLastDelimiter flag to remove last ; or not
 * @returns filter String
 */
const filterStringBuilder = (searchObject, removeLastDelimiter = true) => {
  let filterString = '';
  Object.entries(searchObject)
    .filter(([, value]) => Boolean(value))
    .forEach(([key, value]) => {
      if (key === ROLE_KEY && value === USER_ROLE.BROADCASTER) {
        // NOTE: this logic can be removed as soon as the MEMBER role is purge from our DBs
        filterString += `${key}=in=(${value},MEMBER);`;
      } else {
        filterString += `${key}==${value};`;
      }
    });
  return removeLastDelimiter ? filterString.slice(0, -1) : filterString;
};

export default filterStringBuilder;
